import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import useStyles from './ActionBar.styles';
import ActionBarAction from './ActionBarAction';
import ActionBarSelect from './ActionBarSelect';
import ActionBarSelectOption from './ActionBarSelectOption';
import ActionBarInput from './ActionBarInput';
export const ActionBar = ({ className, variant = 'default', size = 'small', children, }) => {
    const classes = useStyles();
    return (_jsx("div", Object.assign({ className: cn(classes.root, variant === 'footer' && classes.footer, variant === 'floating' && classes.floating, size === 'medium' && classes.medium, size === 'large' && classes.large, className) }, { children: children })));
};
export default Object.assign(ActionBar, {
    Action: ActionBarAction,
    Select: ActionBarSelect,
    SelectOption: ActionBarSelectOption,
    Input: ActionBarInput,
});
//# sourceMappingURL=ActionBar.js.map